import { call, put } from "redux-saga/effects";

import { apiGeneral, notify, queryBuilder } from "services";
import { requestErrorHandler } from "utils";
import { FetchListCarrierContactActions } from "store/ducks/carrier-contact";
import { IListRequest } from "interfaces/list-duck";

export function* fetchListCarrierContactRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder({
      ...query, 
     
    });

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/carrier-contact-by-carrier?${queryString}`
    );

    const data = responseBody;
    yield put(FetchListCarrierContactActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(FetchListCarrierContactActions.failure(errorMessage));
  }
}
